import { PostboxDocument } from 'cpes-common';
import { createGetContractBasedDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

const { reducer, fetchData, updateData, updateState } = createGetContractBasedDataFetchSlice<
    PostboxDocument[],
    DefaultBusinessMarketApiErrorCode
>({
    dataName: 'postboxContract',
    fetchCallback(link: string) {
        return CpDataApi.get(link).then(response => response.data);
    },
});

export default reducer;
export const fetchContractPostbox = fetchData;
export const updatePostboxPerContract = updateData;
export const updateContractPostboxState = updateState;
